"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.devicesReducers = void 0;
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.symbol.description.js");
var _lodash = require("lodash");
var types = _interopRequireWildcard(require("./types"));
var _functions = require("../../../utils/functions");
var _redux = require("../../../Wrap/redux");
var _listeners = require("../../listeners");
var _constants = require("../../../utils/constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /** @todo resolve cycle */ // eslint-disable-next-line import/no-cycle
const initialState = {
  errors: [],
  buildings: [],
  structure: {},
  // {HtgSys: [ component, ... ], ...} -
  devices: {
    byId: {},
    // {[id]: device, ...}
    byPwhC: [],
    // [d_id, ...]
    active: null
  },
  devicePDIDs: [],
  equipmentIds: [],
  values: {
    byId: {} // {[id]: device, ...}
  },

  hasData: false
};

// eslint-disable-next-line default-param-last
const devicesReducers = exports.devicesReducers = function devicesReducers() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let {
    type: actionType,
    payload
  } = arguments.length > 1 ? arguments[1] : undefined;
  switch (actionType) {
    case types.GET_DEVICES_SUCCEEDED:
      {
        const {
          devicePDIDs = [],
          equipmentIds = [],
          entities = []
        } = payload;
        // entities.propTypes = dataType;
        const devicesList = {};
        const equipmentNames = {};
        if (!entities || Array.isArray(entities) && !entities.length) {
          // eslint-disable-next-line no-console
          console.error('GET_DEVICES_SUCCEEDED response:', payload);
          return _objectSpread(_objectSpread({}, state), {}, {
            hasData: false
          });
        }
        const getUpdatedComponentsById = _ref => {
          let {
            components,
            componentType
          } = _ref;
          return components.reduce((accComponent, component) => {
            const {
              devices = []
            } = component;
            let devicesId = devices.reduce((accDeviceIds, device) => [...accDeviceIds, device.thingPDIDDevice], []);
            devicesId = [...new Set(devicesId)]; // remove duplicates
            const equipmentName = component.thingInfoDesignation;
            equipmentNames[component.id] = equipmentName;
            devices.forEach(device => {
              devicesList[device.thingPDIDDevice] = _objectSpread(_objectSpread({}, device), {}, {
                equipmentName,
                building: component.building
              });
            });
            const clonedComponent = (0, _lodash.cloneDeep)(component);
            const newComponent = _objectSpread(_objectSpread({}, clonedComponent), {}, {
              devices: null,
              type: componentType,
              devicesId
            });
            return _objectSpread(_objectSpread({}, accComponent), {}, {
              [component.id]: newComponent
            });
          }, {});
        };
        const newStructure = Object.entries(entities).reduce((accList, _ref2) => {
          let [componentType, components] = _ref2;
          if (componentType === _constants.ComponentTypes.Building || componentType === _constants.ComponentTypes.EdgeNode) {
            return accList;
          }
          const listComponentsByType = getUpdatedComponentsById({
            components,
            componentType
          });
          return _objectSpread(_objectSpread({}, accList), {}, {
            [componentType]: listComponentsByType
          });
        }, {});
        const BuildingIdList = (0, _functions.getBuildingIdList)({
          structure: newStructure
        });

        // const defActiveBuildingId = BuildingIdList && BuildingIdList[0] ? BuildingIdList[0][0] || null : null;
        // const filteredData = getCurrentStructure({structure: newStructure, buildingId: defActiveBuildingId});
        // console.log('filteredData', filteredData)
        // console.log('structure', newStructure)

        // console.log('MDM', payload,
        //     '\n ================== \nActive Structure',
        //     structure.active,
        //     '\n ================== \ndevicesList',
        //     devicesList,
        //     '\n ================== \nstructureByDep',
        //     structureByDep,
        // )

        const buildings = BuildingIdList.map(group => group.map(id => {
          var _entities$Building;
          return ((_entities$Building = entities.Building) === null || _entities$Building === void 0 ? void 0 : _entities$Building.find(building => building.id === id)) || {
            id
          };
        }));
        const htgHxEquipments = entities.HtgHx;
        const htgHxIds = htgHxEquipments.map(equipment => equipment.id);
        const result = _objectSpread(_objectSpread({}, state), {}, {
          allBuildings: entities.Building,
          buildings,
          structure: newStructure,
          equipmentNames,
          devicePDIDs,
          equipmentIds,
          devices: _objectSpread(_objectSpread({}, state.devices), {}, {
            byId: devicesList,
            byPwhC: devicePDIDs
          }),
          hasData: true,
          htgHxEntities: {
            entities: htgHxEquipments,
            ids: htgHxIds
          }
        });
        /** @todo: extending reducers to be read by other packages, discussed for use via saga */
        setTimeout(() => {
          var _store$getState;
          return _redux.store.dispatch((0, _listeners.getDevicesListenerAction)({
            payload: entities,
            result,
            core: (_store$getState = _redux.store.getState) === null || _store$getState === void 0 ? void 0 : _store$getState.call(_redux.store)[_constants.packageKey]
          }));
        }, 1);
        return result;
      }
    case types.GET_VALUE_SUCCEEDED:
      {
        var _device$displayNameId, _ref4, _clonedPayload$thresh2;
        const device = state.devices.byId[payload === null || payload === void 0 ? void 0 : payload.thingPDIDDevice];
        if (!device || !((_device$displayNameId = device.displayNameId) !== null && _device$displayNameId !== void 0 && _device$displayNameId.includes(payload.displayNameId))) {
          return state;
        }
        const clonedPayload = (0, _lodash.cloneDeep)(payload);
        const deviceValuePrev = state.values.byId[clonedPayload === null || clonedPayload === void 0 ? void 0 : clonedPayload.displayNameId] || {};
        clonedPayload.timestamp = Math.max(clonedPayload.timestamp, deviceValuePrev.timestamp || 0);
        if (_constants.regularsByDisplayNameId.temperatureRegex.test(clonedPayload === null || clonedPayload === void 0 ? void 0 : clonedPayload.displayNameId)) {
          var _ref3, _clonedPayload$thresh;
          const temperatureStatus = (0, _functions.getStatusDevice)(_objectSpread(_objectSpread({}, clonedPayload), {}, {
            thresholds: (_ref3 = (_clonedPayload$thresh = clonedPayload.thresholds) !== null && _clonedPayload$thresh !== void 0 ? _clonedPayload$thresh : device.thresholds) !== null && _ref3 !== void 0 ? _ref3 : {}
          }));
          clonedPayload.temperatureStatus = temperatureStatus || clonedPayload.temperatureStatus || {};
        }
        const newState = (0, _lodash.cloneDeep)(state);
        newState.devices.byId[clonedPayload.thingPDIDDevice] = _objectSpread(_objectSpread({}, device), {}, {
          timestamp: Math.max(clonedPayload.timestamp, device.timestamp || 0)
        });
        newState.values.byId[clonedPayload.thingPDIDDevice] = _objectSpread(_objectSpread({}, newState.values.byId[clonedPayload.thingPDIDDevice] || {}), {}, {
          [clonedPayload.displayNameId]: _objectSpread(_objectSpread({}, clonedPayload), {}, {
            thresholds: (_ref4 = (_clonedPayload$thresh2 = clonedPayload.thresholds) !== null && _clonedPayload$thresh2 !== void 0 ? _clonedPayload$thresh2 : device.thresholds) !== null && _ref4 !== void 0 ? _ref4 : {}
          })
        });
        /** @todo: extending reducers to be read by other packages, discussed for use via saga */
        setTimeout(() => {
          var _store$getState2;
          return _redux.store.dispatch((0, _listeners.getValueListenerAction)({
            payload: clonedPayload,
            result: newState,
            core: (_store$getState2 = _redux.store.getState) === null || _store$getState2 === void 0 ? void 0 : _store$getState2.call(_redux.store)[_constants.packageKey]
          }));
        }, 1);
        return newState;
      }
    case types.GET_VALUES_SUCCEEDED:
      {
        if ((0, _functions.isEmpty)(payload)) return state;
        const ById = Object.values(payload).reduce((acc, deviceValue) => {
          var _acc$devices$deviceVa, _acc$devices$deviceVa2, _ref6, _cloneDeviceValue$thr2;
          if (!deviceValue.thingPDIDDevice || !((_acc$devices$deviceVa = acc.devices[deviceValue.thingPDIDDevice]) !== null && _acc$devices$deviceVa !== void 0 && _acc$devices$deviceVa.thingPDIDDevice) || !((_acc$devices$deviceVa2 = acc.devices[deviceValue.thingPDIDDevice].displayNameId) !== null && _acc$devices$deviceVa2 !== void 0 && _acc$devices$deviceVa2.includes(deviceValue.displayNameId))) {
            return acc;
          }
          const cloneDeviceValue = (0, _lodash.cloneDeep)(deviceValue);

          /** @todo: please split this functionality to 2 functions with understandable name, not to use 1-3 letter variables inside. */
          const {
            devices,
            values
          } = acc;
          const device = devices[cloneDeviceValue.thingPDIDDevice] || {};
          const deviceValuePrev = values[cloneDeviceValue === null || cloneDeviceValue === void 0 ? void 0 : cloneDeviceValue.displayNameId] || {};
          if (cloneDeviceValue.timestamp < (deviceValuePrev.timestamp || 0)) {
            cloneDeviceValue.timestamp = deviceValuePrev.timestamp;
          }
          if (_constants.regularsByDisplayNameId.temperatureRegex.test(cloneDeviceValue === null || cloneDeviceValue === void 0 ? void 0 : cloneDeviceValue.displayNameId)) {
            var _ref5, _cloneDeviceValue$thr;
            const temperatureStatus = (0, _functions.getStatusDevice)({
              value: cloneDeviceValue.value,
              timestamp: cloneDeviceValue.timestamp,
              valueType: cloneDeviceValue.valueType,
              thresholds: (_ref5 = (_cloneDeviceValue$thr = cloneDeviceValue.thresholds) !== null && _cloneDeviceValue$thr !== void 0 ? _cloneDeviceValue$thr : device.thresholds) !== null && _ref5 !== void 0 ? _ref5 : {}
            });
            cloneDeviceValue.temperatureStatus = temperatureStatus || cloneDeviceValue.temperatureStatus || {};
          }
          const timestamp = Math.max(cloneDeviceValue.timestamp, device.timestamp || 0);
          return {
            devices: _objectSpread(_objectSpread({}, devices), {}, {
              [device.thingPDIDDevice]: _objectSpread(_objectSpread({}, device), {}, {
                timestamp
              })
            }),
            values: _objectSpread(_objectSpread({}, values), {}, {
              [cloneDeviceValue.thingPDIDDevice]: _objectSpread(_objectSpread({}, values[cloneDeviceValue.thingPDIDDevice] || {}), {}, {
                [cloneDeviceValue.displayNameId]: _objectSpread(_objectSpread({}, cloneDeviceValue), {}, {
                  thresholds: (_ref6 = (_cloneDeviceValue$thr2 = cloneDeviceValue.thresholds) !== null && _cloneDeviceValue$thr2 !== void 0 ? _cloneDeviceValue$thr2 : device.thresholds) !== null && _ref6 !== void 0 ? _ref6 : {}
                })
              })
            })
          };
        }, {
          devices: state.devices.byId,
          values: state.values.byId
        });
        const newState = (0, _lodash.cloneDeep)(state);
        newState.devices.byId = ById.devices;
        newState.values.byId = ById.values;

        /** @todo: extending reducers to be read by other packages, discussed for use via saga */
        setTimeout(() => {
          var _store$getState3;
          return _redux.store.dispatch((0, _listeners.getValuesListenerAction)({
            payload,
            result: newState,
            core: (_store$getState3 = _redux.store.getState) === null || _store$getState3 === void 0 ? void 0 : _store$getState3.call(_redux.store)[_constants.packageKey]
          }));
        }, 1);
        return newState;
      }
    case types.GET_DEVICE_VALUES_SUCCEEDED:
      {
        if ((0, _functions.isEmpty)(payload)) return state;
        const byId = payload.reduce((acc, deviceValue) => {
          var _accumulatorDevice$de, _accumulatorDevice$de2, _accumulatorDevice$de3;
          if (!deviceValue.thingPDIDDevice) return acc;
          const {
            thingPDIDDevice,
            type,
            value,
            timestamp,
            deviceError
          } = deviceValue;
          const device = state.devices.byId[thingPDIDDevice] || {};
          const accumulatorDevice = acc[thingPDIDDevice] || {};
          const storedErrorTimestamp = ((_accumulatorDevice$de = accumulatorDevice.deviceError) === null || _accumulatorDevice$de === void 0 ? void 0 : _accumulatorDevice$de.timestamp) || 0;
          const isAccumulatorDeviceError = (accumulatorDevice === null || accumulatorDevice === void 0 || (_accumulatorDevice$de2 = accumulatorDevice.deviceError) === null || _accumulatorDevice$de2 === void 0 ? void 0 : _accumulatorDevice$de2.error) && (accumulatorDevice === null || accumulatorDevice === void 0 || (_accumulatorDevice$de3 = accumulatorDevice.deviceError) === null || _accumulatorDevice$de3 === void 0 ? void 0 : _accumulatorDevice$de3.timestamp);
          const isNewValueDeviceError = deviceError && timestamp;
          const shouldReplaceStoredError = !isAccumulatorDeviceError || isNewValueDeviceError && timestamp > storedErrorTimestamp;
          const updatedTimestamp = Math.max(timestamp, device.timestamp || 0);
          const updatedCurrentMetricTimestamp = Math.max(updatedTimestamp, accumulatorDevice.timestamp || 0);
          return _objectSpread(_objectSpread({}, acc), {}, {
            [thingPDIDDevice]: _objectSpread(_objectSpread({}, accumulatorDevice), {}, {
              [type]: value,
              deviceError: shouldReplaceStoredError ? {
                error: deviceError,
                timestamp
              } : accumulatorDevice.deviceError,
              timestamp: updatedCurrentMetricTimestamp
            })
          });
        }, state.devices.byId);
        const result = _objectSpread(_objectSpread({}, state), {}, {
          devices: _objectSpread(_objectSpread({}, state.devices), {}, {
            byId
          })
        });
        /** @todo: extending reducers to be read by other packages, discussed for use via saga */
        setTimeout(() => {
          var _store$getState4;
          return _redux.store.dispatch((0, _listeners.getDeviceValuesListenerAction)({
            payload,
            result,
            core: (_store$getState4 = _redux.store.getState) === null || _store$getState4 === void 0 ? void 0 : _store$getState4.call(_redux.store)[_constants.packageKey]
          }));
        }, 1);
        return result;
      }
    case types.GET_DEVICE_VALUE_SUCCEEDED:
      {
        var _device$deviceError, _device$deviceError2;
        if (!(payload !== null && payload !== void 0 && payload.thingPDIDDevice)) return state;
        const device = state.devices.byId[payload.thingPDIDDevice] || null;
        if (!device) return state;
        const result = _objectSpread(_objectSpread({}, state), {}, {
          devices: _objectSpread(_objectSpread({}, state.devices), {}, {
            byId: _objectSpread(_objectSpread({}, state.devices.byId), {}, {
              [payload.thingPDIDDevice]: _objectSpread(_objectSpread({}, device), {}, {
                deviceError: !(device !== null && device !== void 0 && (_device$deviceError = device.deviceError) !== null && _device$deviceError !== void 0 && _device$deviceError.error) || payload.deviceError && payload.timestamp && payload.timestamp > (device === null || device === void 0 || (_device$deviceError2 = device.deviceError) === null || _device$deviceError2 === void 0 ? void 0 : _device$deviceError2.timestamp) ? {
                  error: payload.deviceError,
                  timestamp: payload.timestamp
                } : device.deviceError,
                [payload.type]: payload.value,
                timestamp: payload.timestamp > (device.timestamp || 0) ? payload.timestamp : device.timestamp
              })
            })
          })
        });
        /** @todo: extending reducers to be read by other packages, discussed for use via saga */
        setTimeout(() => {
          var _store$getState5;
          return _redux.store.dispatch((0, _listeners.getDeviceValueListenerAction)({
            payload,
            result,
            core: (_store$getState5 = _redux.store.getState) === null || _store$getState5 === void 0 ? void 0 : _store$getState5.call(_redux.store)[_constants.packageKey]
          }));
        }, 1);
        return result;
      }
    case types.UPDATE_TEMPERATURE_STATUSES:
      {
        const updateStatus = function updateStatus() {
          var _Object$values;
          let valuesById = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return ((_Object$values = Object.values(valuesById)) === null || _Object$values === void 0 ? void 0 : _Object$values.reduce((accValue, value) => {
            if (_constants.regularsByDisplayNameId.temperatureRegex.test(value === null || value === void 0 ? void 0 : value.displayNameId)) {
              return _objectSpread(_objectSpread({}, accValue), {}, {
                [value.displayNameId]: _objectSpread(_objectSpread({}, value), {}, {
                  temperatureStatus: (0, _functions.getStatusDevice)(value)
                })
              });
            }
            return _objectSpread(_objectSpread({}, accValue), {}, {
              [value.displayNameId]: value
            });
          }, {})) || {};
        };
        const valuesById = Object.values(state.devices.byId).reduce((accValues, device) => {
          if (!device.thingPDIDDevice) {
            // eslint-disable-next-line no-console
            console.error('Empty device', device);
            return accValues;
          }
          return _objectSpread(_objectSpread({}, accValues), {}, {
            [device.thingPDIDDevice]: updateStatus(accValues[device.thingPDIDDevice])
          });
        }, state.values.byId);
        const newState = (0, _lodash.cloneDeep)(state);
        newState.values.byId = valuesById;
        /** @todo: extending reducers to be read by other packages, discussed for use via saga */
        setTimeout(() => {
          var _store$getState6;
          return _redux.store.dispatch((0, _listeners.updateTemperatureStatusesListenerAction)({
            payload,
            result: newState,
            core: (_store$getState6 = _redux.store.getState) === null || _store$getState6 === void 0 ? void 0 : _store$getState6.call(_redux.store)[_constants.packageKey]
          }));
        }, 1);
        return newState;
      }
    case types.RESET_ALL_DEVICES_CORE:
      return initialState;
    case types.GET_DEVICES_FAILED:
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: [...state.errors, _objectSpread({
          method: 'getDevices'
        }, payload)]
      });
    case types.GET_VALUE_FAILED:
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: [...state.errors, _objectSpread({
          method: 'getValue'
        }, payload)]
      });
    case types.GET_VALUES_FAILED:
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: [...state.errors, _objectSpread({
          method: 'getValues'
        }, payload)]
      });
    case types.GET_DEVICE_VALUES_FAILED:
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: [...state.errors, _objectSpread({
          method: 'getDeviceValues'
        }, payload)]
      });
    case types.GET_DEVICE_VALUE_FAILED:
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: [...state.errors, _objectSpread({
          method: 'getDeviceValue'
        }, payload)]
      });
    /** @todo: we should discuss it together with Yuriy and Designers */
    default:
      return state;
  }
};